export default {
  // header
  "Hello,": 'Hello,',
  "Login": "Login",
  "Register": "Register",
  'Profile': 'Profile',
  'Test Results': 'Test Results',
  'Wrong Bookmark': 'Wrong Bookmark',
  'Settings': 'Settings',
  'Logout': 'Logout',
  'Download': 'Download',
  'IELTS': 'IELTS',
  'TOEFL': 'TOEFL',
  'Home': 'Home',
  'Download': 'Download',
  'VIP': 'VIP',

  'Active VIP': 'Active VIP',

  'officialExam': 'Official Exam',
  'allFree': 'All Free',
  'undisclosedExam': 'Undisclosed Exam',
  'partlyFree': 'Partly Free',


  // headertwo
  'TOEFL Home': 'TOEFL Home',
  'Exam Mock': 'Exam Mock',
  'Reading': 'Reading',
  'Listening': 'Listening',
  'Speaking': 'Speaking',
  'Writing': 'Writing',
  'Search': 'Search',
  'TPO All Free': 'TPO-17 & 5  Undisclosed',
  'Sections Together': '4 Sections Together',
  'Reading Section Free': '34 Reading Section Free',
  'Section': 'Section',
  'Articles Get Score': '2 Articles Get Score',
  'SequentialHome': 'Sequential',
  'SingleArticles': 'Single Articles',
  'TopicExercise': 'Topic | Frequency',
  '5 Records Get Score': '5 Records Get Score',
  'No duplication In_Exam with Out_Exam': 'No duplication In_Exam with Out_Exam',
  '5个/6个录音 完成后出分': '5个/6个录音 完成后出分',
  'Single Record': 'Single Record',
  'Single Question': 'Single Question',
  '题材分类-单个题目练习': '题材分类-单个题目练习',
  '4 Question': '4 Question',
  //GRE headertwo
  'GRE Home': 'GRE Home',
  'Chinese': "Chinese",
  'Maths': 'Maths',
  "写作.语文.数学一起模考": "写作.语文.数学一起模考",
  "disclosed All Free": "disclosed All Free",

  'TPO_In_Exam': 'TPO_In_Exam',
  'TPO_Out_Exam': 'TPO_Out_Exam',
  'toeflTPO': 'TPO',
  'Undis_In_Exam': 'Undis_In_Exam',
  'Undis_Out_Exam': 'Undis_Out_Exam',
  '4 Question Writing': '2 Question',
  'Undisclosed': 'Undisclosed',
  '': '',
  '': '',
  //index

  'In_Exam_tpo': 'In_Exam',
  'Out_Exam_tpo': 'Out_Exam',


  'In_Exam': 'In_Exam',
  'Out_Exam': 'Out_Exam',
  '': '',
  '2014-2015 Free': '2014-2015 Free',
  'TPO Exam': 'TPO Exam',
  'oforq': 'Officially open retired questions.All free',
  'ieaoa': 'In_Exam and out_exam are not duplicated',
  'ieaond': 'In_Exam and out_exam not duplicated',
  'eiiitt': 'Description: In_Exam is identical to the individual on the right. Choose different exercises',
  'View Details': 'View Details',
  'completeSet': 'Complete Set',
  'outOfSetT': 'Out-of-set',
  'Fully simulated exams': 'Fully simulated exams',
  'Interface Exactly the same': 'Interface Exactly the same',
  'dotrq': 'Description of the Real questions',
  'aqafre': 'All questions are from Real exam.',
  'far': '2021-2024 fully adapted  2023 reform.',
  'itlaw': 'Including the latest academic writing.',
  'sqaf': 'Some questions are free.',
  'affvm': 'All free for VIP members.',
  'uem': 'Undisclosed Exam Mock',
  'Officially open retired questions.TPO1-75 are all free': 'Officially open retired questions.TPO1-75 are all free',
  'Index d1': 'Reform Details. Starting July 26, 2023 . TOEFL reduced from 3 hours to 2 hours. Speaking remain unchanged, while Reading, Listening and Writing changed in content and time. TPO1-63 are before the 2019 reform, and TPO64-75 are  after the 2019 reform. We have adjusted the question bank, removed the redundant article and reorganized new set of extra questions.',
  'Index d2': ' ',
  'Index d3': ' ',
  'Index d4': '',
  'Start Exams': 'Start Exams',
  'Reform Summary': 'Reform Summary',
  'Entire Set': 'Entire Set',
  'Complete set of exercises': 'Set exercises',
  'Score out': '5 Records.Get Score',
  'Single Article Exercise': 'Topic order',
  'single recording exercise': 'Topic classification',
  'exercises/mock exams': '2 exercises/mock exams',
  'single Question Exercise': 'Topic Classification',
  'Topic order': 'Topic order',
  'Topic classification': 'Topic classification',
  'tpoExam': 'Exam',
  'TPOReading': 'Reading',
  'TPOListening': 'Listening',
  'TPOSpeaking': 'Speaking',
  'TPOWriting': 'Writing',
  "3 Articles Get Score": '2 Articles Get Score',
  'Topicclassification': 'Topic classification',
  "4Questions": "4 Questions",
  "2Questions": "2 Questions",
  "Classification": "Topic Classification",
  "topicclassification": "Topic classification",
  'Records.GetScore': '5 Records.Get Score',
  // 'Index d3': ' 该练习材料全部出自在考真题，是ETS未公开开练习素材.通过特殊渠道获取。听力,口语,写作都是适应改革后的题库.阅读20年往后都是改革的试题.10个题/篇,2014-2019还是是14题/篇.没有适应新政.因为真题比较宝贵,没有删除多余的题目,',
  // 'Index d4': '其中2014-2015年阅读真题免。',
  'Index d5': 'View differences',
  'Index d6': 'Mock exam',
  'Index d7': 'This exercise material is all from the actual exam questions and is not publicly available by ETS. It is obtained through special channels. Reading, listening, speaking, and writing are all question banks adapted to the reform.',
  'Index d8': 'Among them, the 2014-2015 reading test questions were free of charge.',

  'Undisclosed Exam': 'Undisclosed Exam',
  'ouispf': 'Officially unpublished in service. Partly free',
  'ReadingZT': 'Actual Reading',
  'ListeningZT': 'Actual Listening',
  'SpeakingZT': 'Actual Speaking',
  'WritingZT': 'Actual Writing',
  '整套练习/模考': '整套练习/模考',
  'Topic Out Exam': '套题外题目',
  'Topic': 'Topic Exercise',
  '4个题目练习/模考': "4个题目练习/模考",
  'exam': 'Exam',
  //gre index
  "公开套题": "公开套题",
  "Verbal": "Verbal",
  "Verbal Reasoning": "Verbal Reasoning",
  "Secction Mock/Pratic": "Secction Mock/Pratic",
  "Reading&Logic": "Reading&Logic",
  "Quantitative Reasoning": "Quantitative Reasoning",
  "2/3个Quantitative练习/模考": "1 Quantitative Section",
  "题型练习": "Question Type",
  "套题模考": "Exam Mock",
  "Entire Set": "Entire Set",
  "一起模考.模拟考试场景": "Practice exams together. Mock test scenarios",
  "Secction练习/模考": "Secction Mock/Pratic",
  "1个Verbal练习/模考": "1 Verbal practice/mock",
  "多篇/单篇文章练习": "Multiple/single article",
  "知识点练习": "Knowledge",
  "多个/单个 知识点练习": "Multiple/single knowledge",
  "Analytical Writing": "Analytical Writing",
  "lssue练习": "lssue",
  "Issue单个题目练习": "Single Question",
  "Argument": "Argument",
  "Argument-单个题目练习": "Single Question",
  "Equivalenc and Filling in the blanks": "Equivalenc and Filling in the blanks",
  "多个/单个题目练习": "Multiple/single Question",
  "2个写作题目": "2 writing topics",
  "2/3个Verbal": "2/3 Verbal",
  "2/3个Quantitative": "2/3 Quantitative Practice exams tog",
  "Quantitative": "Quantitative",
  "Writing": "Writing",
  'Officially open retired questions.free': '｜官方未公开的在考真题.通过特殊渠道获取.部分真题免费',
  "OfficialInstructions": "Description",
  "Material description": "Description",
  'GRE complete set contains': 'GRE完整套题包含',
  'GRE Index d1': '1.官方指南中配套的4套题.',
  'GRE Index d2': '2.官方在线模考软件中:提供了2套仿真系统，这2套系统中共包含了5套完整的GRE的题目，官方叫做Power Pop Online，简称PPO.',
  'GRE Index d3': '3.Power PlusOnline简称PPO plus.包含了三套官方真题',
  'GRE Index d4': '4.PP2: PP2其实是 prep的本地软件.',
  'SectionNote': "注意",
  'SectionNoteInfo': "以上都是GRE官方正式出版的套题.都是2015年以前的题.虽然是官方风格,但是与2020年以及的考试题在风格上还是有一些细微的区别,不会在未来的考试当中重复出现。所以上述的套题可以作为备考的补充材料",
  "Description": "Description",
  "DescriptionInfo": "GRE writing questions are publicly available. It is updated slightly each year. Each test is drawn from the public pool of questions. All the questions are organized in the following section of the test.",
  "completeSet": "Complete Set",
  "outOfSet": "Out-of-set questions",
  "chargeSectionDescription": "The practice materials are all from real exams. It is obtained through special channels. All the questions are from the real exams after 2020. There is a high probability that they will be tested again in future exams.",
  //browe
  'Download Record': 'Download Record',
  'RepeatDate': "RepeatDate",
  'Script': "Script",
  'Note': "Note",
  'Favorite': "Favorite",
  'Report': "Report",
  'Speaking': "Speaking",
  'Hide Answer': "Hide Answer",
  'Show Answer': "Show Answer",
  'Answer': "Answer",
  'Time': "Time",
  'History': "History",
  'Article Explanation': "Article Explanation",
  'Question Explanation': "Question Explanation",
  'Browe d1': "此解析可拖动.方便看解析",
  'Reset': "Reset",
  'QR code': "QR code",
  'Avatar': "Avatar",
  'Mentor Name': "Mentor Name",

  //testReport

  /*********exam-TPO-GRE**********/
  'Enter Exam': 'Enter',
  'Average website score': 'Average score',
  'Score': 'Score',
  'Exam INSTRUCTION': 'Exam INSTRUCTION',
  'Hide': 'Hide',
  'Show': 'Show',
  'TPO&Undisclosed&&In_Exam&Out_exam Description': 'TPO&Undisclosed&&In_Exam&Out_exam Description',
  'Exam d1': 'From July 26, 2023. The TOEFL exam is undergoing a new reform. The TOEFL exam will be shortened from 3 hours to 2 hours. In addition to the speaking test, the content and time of the reading, listening, and writing tests will be changed. TPO1-63 are the questions before the 2019 reform, TPO64-75 are the questions after the 2019 reform. TPO1-75 have been adapted to the 23 years reform. The official release of the post-23 years test questions is being updated.......',
  'GRE Exam INSTRUCTION': 'GRE Exam INSTRUCTION',

  //footer
  'About Us': 'About Us',
  'Contact': 'Contact',
  'Cooperation': 'Cooperation',
  'Help': 'Help',
  'Links': 'Links',
  'Website Version': '版权所有 知学君 京ICP备16042710号-1 Copyright ©2017',




  //button
  'original button': 'original-en',
  'trans button': 'trans-en',
  'explain button': 'explain-en',
  'replay button': 'replay-en',
  'flag button': 'flag-en',
  'note button': 'note-en',
  'locate button': 'locate-en',
  'dict button': 'dict-en',
  'report button': 'report-en',


  //sign up
  'User Agreement': 'User Agreement',
  'User Privacy Policy': 'User Privacy Policy',
  "receive message": 'Message and data rates may apply. Enter your phone number to receive one time passcode message to your phone. Msg freq may vary Reply “HELP” for help, Reply “STOP” to cancel.',
  "Sign up": "Sign up",
  "Log in": "Log in",
  "I agree to receive text message": "I agree to receive text message",
  'I have read and agree to': 'I have read and agree to',
  'Get verification code': 'Get Code',
  'seconds to re-acquire': 'sec',
  'Refresh': 'Refresh',
  'Forgot password?': 'Forgot password?',
  'Reset2': 'Reset',
  'The phone you entered is incorrect': 'The phone you entered is incorrect',
  'CAPTCHA': 'CAPTCHA',
  'Enter the full mobile phone number to get the picture verification code': 'Enter mobile  get picture code',
  'And': 'And',
  'Return to the homepage': 'Return Home',
  'Save': 'Save',
  'Reset password': 'Reset password',
  'Password reset successfully': 'Password reset successfully',
  'Mobile phone verification code': 'Mobile phone verification code',
  'Please enter the login password': 'Please enter the login password',
  'Please enter the invitation code': 'Please enter the invitation code',
  'official account': 'Scan  code  add  whatsApp',
  'zhixuejunred': '',
  'Follow to avoid losing contact': '',
  "customer service WeChat": "WeChat",
  'Current': 'Current',
  'registration. Login is only available to some users': 'registration. Login is only available to some users',
  'Dear user': 'Dear user',
  'You can add the customer service WeChat to get an invitation code. Registration is free': 'You can add the customer service WeChat to get an invitation code. Registration is free',
  'Additional instructions': 'Other Description',
  'Follow the Official  AccountsPlatform.The site may not be accessible': 'Follow the Official  whatsapp.The site may not be accessible',
  'You can contact us via whatsapp': 'You can contact us via whatsapp',
  'Contact us via email  b120346@163.com': 'Contact us via email  b120346@163.com',
  'Verification code error': 'Verification code error',
  'Please enter the password': 'Please enter the password',
  'The verification code has been sent successfully, please check your messages.': 'The verification code has been sent successfully, please check your messages.',
  'Please agree to the Terms of Service and Privacy Policy first.': 'Please agree to the Terms of Service and Privacy Policy first.',
  'Please enter the picture verification code': 'Please enter the picture verification code',
  'The password must be 4-12 characters long': 'Please enter 4-12 characters',
  'Please re-enter the password': 'Please re-enter the password',
  "The passwords entered do not match": "The passwords entered do not match",

  // vip
  'yanv': 'You are not VlP.',
  'Only shows': 'Only shows',
  'odpqb': 'Free Questions',
  'View VIP': 'View VIP',
  'Membership Privileges': 'Membership Privileges',
  'Become VlP member': 'Become VlP',

  'buyNow': 'Buy Now',
  'freeTrial': 'Free Trial',
  'vipinfo1': 'Hundreds of In-service exam. NOT TPO. Adapted to 23-year reform',
  'vipinfo2': 'Perfectly simulate the exam. Same interface and functions',
  'vipinfo3': 'Sets of questions. Individual Topics Variety of exercises',

  'cmb': 'Comparison of Membership Benefits',
  'xys': 'Xiao Yi Si&Zhi Xue Jun chooses a more suitable one for himself',
  'why': 'Why ',
  'cz': 'choose Zhixuejun',
  'lqbf': 'List of Question Bank Features',
  'faq': 'FAQ ',

  'xiaoyisi': 'Xiao Yi Si',
  'zhixuejunred': 'Zhi Xue Jun',

  'free': 'Free',
  'freePay': 'Free-Paying',
  'daoFree': '￥0',
  'daoFreePay': '￥239',
  'permanent': 'permanent',

  'esis': 'Exam Sets in service',
  'Actual Reading': 'Actual Reading',
  'Actual Listening': 'Actual Listening',
  'Actual Speaking': 'Actual Speaking',
  'Actual Writing': 'Actual Writing',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  'set': '5 Set',
  'set41': '79 Set',
  'set75': '75 Set',
  'ar': 'Actual Reading',
  'section45': '45 Section',
  'section5': '5 Section',
  'section75': '75 Section',
  'section99': '128 Section',
  'section45': '45 Section',
  'section92': '141 Section',
  'section84': '122 Section',
  'section185': '257 Section',
  'section41': '41 Section',
  'year2020': '2014-2020',
  'year2024': '2014-2024',
  'QuestionPeriod': 'Question Period',
  'nsu': 'Non-scheduled update',

  'pr': 'Perfect Reproduction',
  'ibs': 'Interface.Buttons. Same as the Exam',
  'taimof': 'The audition interface mimics official features.',
  'raibjlte': 'Read article icon. Buttons. Just like the exam',
  'rpaslte': 'Recor playback.Answer screen. Like the exam.',
  'oarjlte': 'Oral Answers: Recorded. Just like the exam.',
  'wfijlt': 'Writing : functional interface Just like the exam',

  'mpm': 'Multiple Practice Modes',
  'estp': 'Exam .Section .Topic Practice',
  'e4pme': 'Exams: 4Sections. Perfect Mock Exam',
  'smise': 'Section Mock :Individual Section Exercises.',
  'teoare': 'Topic Exercise. One Article/Record/Ouesiton Exercise',

  'peo': 'Powerful. Excellent',
  'bnwqe': 'Bookmark.Note.Wrong questions, etc.',
  'ycbtayr': 'You can bookmark the article.Title.Recordings, etc',
  'ncbtatr': 'Notes can be added.skip questions. Skip recordings',
  'mccwqao': 'Member Centre:Collection. Wrong questions and other',
  'qadr': 'Question Analysis.Demonstration recordings',


  'faqTitle1': "What is the real test questions? What's the difference with TPO and JJ?",
  'faqAnswer1': '(1)Real exam questions:In-service exam questions.TPO:retired questions.JJ: Exam Recall Repeat',
  'faqAnswer2': '(2)The Real questions and TPO are complete questions.',
  'faqAnswer3': '(3)The difficulty level of the Real Exam is the same as that of the exam, while the TPO is slightly lower than the exam.',
  'faqAnswer4': '(4)lt is possible to meet the Real questions in the exam. lt is impossible to meet the original questions in the TPO.',

  'faqTitle2': "Is there a high probability of repetition? Are you sure you will meet theoriginal questions? Are you sure it's the original question?",
  'faqAnswer5': "(1)The official question bank is very large. We only have a small part of it. The probability of encountering them is not high. lt's mainly for practice.",
  'faqAnswer6': '(2)There are many users in the group who have reported that they have encountered the original questions. We get feed-back every month.',
  'faqAnswer7': '(3)100% original questions. You can do the free question bank first. lf you feel good, then buy it.',

  'faqTitle3': 'How many sets of questions are there?',
  'faqAnswer8': '(1) Examm 49 sets. Reading 194 sets. Listening 100 sets. Speaking 92 sets. Writing 99 sets.',
  'faqAnswer9': '(2)Exam means: listening, reading, writing and speaking in a complete exam.',
  'faqAnswer10': '(3)Reading 2 articles. Listening 5 recordings. 4 questions for Speaking. 2 questions in Writing.',
  'faqAnswer11': '(4)Note: The questions inside the set are not repeated in the questions outside the set.',

  'faqTitle4': 'When is the question bank? ls it suitable for the post-reform period?',
  'faqAnswer12': '(1)The question bank is 2014-2023.The website is adapted to the reformed style.',
  'faqAnswer13': '(2)Reading 2/article 20 questions.Listening 5 recordings 28questions, Speaking 4 questions. Writing 2 questions.',
  'faqAnswer14': '(3)Speaking:1 independent and 3 integrated. Writing: one synthesis +one academic discussion.',
  'faqAnswer15': '(4)Note:2014-2019 reading is 14 questions/article.',

  'faqTitle5': 'How often is the question bank updated? Updated to what time?',
  'faqAnswer16': '(1)lrregularly, when you get the question bank, it will be up-dated. Can not be updated.',
  'faqAnswer17': '(2)The question bank is difficult to get. it may not be updated continuously.lt has been updated for more than 3 years.',
  'faqAnswer18': '(3)The question bank is not updated every time after the exam.It is not possible to update it after the exam.',

  'faqTitle6': 'Do you have the answers, model text and origin-al text?Are all the answers correct?',
  'faqAnswer19': '(1)There is no analysis for reading and listening, but there are reference answers. Listening has the original text. Most of the independent speakers have model essays. There is no model text for General.',
  'faqAnswer20': '(2)The questions are obtained from special sources, there is nostandard answer, so there may be mistakes.',
  'faqAnswer21': '(3)The question bank has been updated for many rounds. Errors are rare. We will continue to improve it.',

  'faqTitle7': 'What is the quality of the recordings?',
  'faqAnswer22': '(1)The quality of the recordings in the question bank is both very good and average.',
  'faqAnswer23': '(2)The very good ones account for about 30-40% of the ques-tion bank, and the average ones account for about 50%.',
  'faqAnswer24': '(3)The recordings are very good. lt is convenient for you to take a practice test.',

  'faqTitle8': 'How many computers are bound? Can l changen computers? Can l get a refund if l am not satisfied?',
  'faqAnswer25': "(1)You can buy up to 2 computers at a time. You can't change computers after binding. Can not be cancelled.",
  'faqAnswer26': '(2)Refund is not supported, please try it first and buy it after you are satisfied.',


  'faqTitle9': 'How long is the question bank valid?',
  'faqAnswer27': '(1)lt is valid forever after purchase. Bound computer.Do not change the computer permanent use.(2)The question bank is free to update.',


  'faqTitle10': 'I am not in mainland China , can l use it?',
  'faqAnswer28': '(1)Anywhere you have internet access, you can try the free question bank. lf you have no problem, you can buy it again.',


  'faqTitle11': 'Can l buy only one item or part of the question bank?',
  'faqAnswer29': "(1)No, you can't. The cost of buying questions is high. The profit is too thin.",

  'Usage suggestions': 'Usage suggestions',
  'Pre-exam Sprint difficulty': 'Pre-exam Sprint difficulty',
  'Exam proximity': 'Exam proximity',
  'TPO Practice Suggestions': 'TPO Practice Suggestions',


  'System Features': 'System Features',
  'Key Features': 'Key Features',
  'Descriptions': 'Descriptions',
  'Score': 'Score',
  'Reading. Listening can be graded': 'Reading. Listening can be graded',
  'ralsiicb': 'Reading and listening sets. Individual items can be scored at the end of the test. Speaking and writing are not graded.',

  'Exam Set': 'Exam Set',
  'Exams Mock': 'Exams Mock',
  'avlraw': 'A complete listening, reading and writing practice test, No breaks. Complete modelling of the exam environment.',

  'General Features': 'General Features',
  'Model Test': 'Model Test',
  'Browsing': 'Browsing',
  'Exercise': 'Exercise',
  'Report': 'Report',
  'imtr2': 'Individual Mock Tests. Reading 2 articles/Listening 5 recordings/Speaking 4 topics/Writing 2 topics Mock test. Test report will be issued after completion.',
  'ipr2': 'Individual Practice. Reading 2 articles/Listening 5 recordings',
  'Sequential practice': 'Sequential practice.',
  'btqace': 'Browse test questions and check explanations.',
  'sra': 'Statistical report analysis.',

  'Sequential': 'Sequential',
  'General Feature': 'General Features',
  'Article Translation': 'Article Translation',
  'Title Analysis': 'Title Analysis',
  'Listening Original': 'Listening Original',
  'Model Recording': 'Model Recording',
  'Writing Demo': 'Writing Demo',
  'aaa55': 'All articles after .55 in the 1-75 question bank have no translation. No analysis.No modeltext. No model recordings.',
  'nafar': 'No analysis for all real exams. All the real questions have original texts. No model text. No. model text.',

  'Other Features': 'Other Features',
  'Favourite Function': 'Favourite Function',
  'Wrong Question Function': 'Wrong Question Function',
  'Word Book': 'Word Book',
  'Sentence Book': 'Sentence Book',
  'Article Skipping': 'Article Skipping',
  'Recording Multiplication': 'Recording Multiplication',
  'Recording Jump': 'Recording Jump',
  'Recording Replay': 'Recording Replay',
  'Spoken Word Recording': 'Spoken Word Recording',
  'Progress Curve': 'Progress Curve',
  'yHistory': 'yHistory',
  'fwqba': 'Favourites/Wrona Questions, Bookmark Articles, Favourite Recordinas, Collect QuestionsReading Error. Listening mistakes.',
  'wbsbaw': 'Word Book/Sentence Book:Add words to Word Book. Add sentences to sentence book.',
  'ajjtat': 'Article Jumping:Jump to any topic.',
  'rsmrs': 'Recording Speed: Multiple recording speeds.',
  'pcycat': 'Progress Curve:You can see the progress curve of reading and listening scores in themember centre.',
  'hycdtq': 'History: You can do the questions many times. You can see the progress curve of reading. and listening scores in the member centre.',
  'VIP & Normal': 'VIP & Normal',
  'Dear User': 'Dear User',
  'You are already VIP': 'You are already VIP',
  'All questions': 'All questions',
  'allquestions': '',
  'Free Updates': 'Free Updates',
  'freeupdates': '',
  'Other being': 'Other being',
  'updated': 'updated',


  // router name
  'MockRouter': 'Mock',
  'ToeflRouter': 'Toefl',
  'MockExamRouter': 'Undisclosed Exam Mock',



  'before': 'B',
  'after': 'A',
  'Reformed': 'Reformed ',
  'Previous': 'Previous',
  'Next': 'Next',

  '3-4 Articles  12-14  Ques/Article': '3-4 Articles  12-14  Ques/Article',
  '60-80 min  May be Additional Tests': '60-80 min  May be Additional Tests',
  '10 minutes break': '10 minutes break',
  '3-4 Articles  10  Ques/Article': '3-4 Articles  10  Ques/Article',
  '54-72min  May be Additional Tests': '54-72min  May be Additional Tests',
  '2 Articles  10  Ques/Article': '2 Articles  10  Ques/Article',
  'min': 'min',
  'Cancel Additional': 'Cancel Additional',
  'Cancel break': 'Cancel break',
  '2-3 conversation 5 Ques/Record': '2-3 conversation 5 Ques/Record',
  '4-6 lectures 6 Ques/Record': '4-6 lectures 6 Ques/Record',
  'minutes': 'minutes',
  'add to an examination': '',
  'lectures 6 Ques/Record': 'lectures 6 Ques/Record',
  '2 Conversation 5 Ques/Record': '2 Conversation 5 Ques/Record',
  'CancelAdditional': 'Cancel Additional',
  '6 tasks(2 Indepe +4Integ)': '6 tasks(2 Indepe +4Integ)',
  'Tasks': 'Tasks',
  'Indepe': 'Indepe',
  'IntegSpeaking': 'Integ',
  'IntegWriting': 'Integ',
  'Integ': 'Integ',
  'IndepeWriting': 'Indepe',
  'independent writing': 'Indepe',
  'to': '-',




  'dictationAndReading': '听写跟读',

  'WS': 'WS',
  'KLSFY': 'KLSFY',
  'KLS': 'KLS',
  'NJ': 'NJ',
  'KLSFY': 'KLSFY',
  'LG': 'LG',

  'CustomerServices': 'Customer Services',
  'help': 'Help',


  'ReadStatistics': 'STATISTICS',
  'ListenStatistics': 'STATISTICS',
  'TotalCount': 'Total Count',
  'Right': 'Right',
  'Wrong': 'Wrong',
  'NotAnswered': 'Not Answered',
  'Part': 'Part',
  'TotalExamTime': 'Total exam time',
  'MyTotaltime': 'My Totaltime',
  'TotalNumber': 'Total number',
  'AverageAnswerTime': 'Average answer time',
  '': '',
  '': '',
  '': '',

}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js